var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-input__container"},[_c('div',{class:{
      'app-input': true,
      'app-input__active': _vm.isFocused || _vm.value.toString(),
      'app-input__focus': _vm.isFocused,
    }},[_c('label',{class:`app-input__label ${_vm.labelClass}`,attrs:{"for":_vm.name}},[_vm._v(_vm._s(_vm.label))]),_c('input',{class:_vm.inputClass,attrs:{"type":"text","id":_vm.name,"name":_vm.name,"required":_vm.required},domProps:{"value":_vm.value},on:{"input":_vm.inputPointsHandle,"focus":_vm.focusInputHandle,"blur":_vm.blurInputHandle}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }